<script>
import Dropdown from 'primevue/dropdown';

export default {
    components: {Dropdown},
    data(){
        return{
            options: [
                {
                    label: '',
                    value: null
                },
                {
                    label: this.$t('yes'),
                    value: true
                },
                {
                    label: this.$t('no'),
                    value: false
                }
            ]
        }
    }
}

</script>

<template>
    <Dropdown :options="options" optionValue="value" optionLabel="label" />
</template>